import React from "react";

interface IProps {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<any, IProps> {
  constructor(props: IProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: IProps) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    // You can also log the error to an error reporting service
    console.error(error.message);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <>
          <h1>Something went wrong.</h1>
        </>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
